module.exports = {"download":"Download APP","downloadDes":"App for iOS and Android","scan":"Please scan QR by Phone!","title":"Septekon APP Download"}


//////////////////
// WEBPACK FOOTER
// ./src/common/i18n/app-en.json
// module id = dE3O
// module chunks = 2